import React, { Fragment, useState } from 'react';
import YoutubeSnippet from '../Pages/Snippets/YoutubeSnippet';
import ImageSnippet from '../Pages/Snippets/ImageSnippet';
import CreateProduct from '../Pages/CreateProduct';
import CustomModal from './CustomModal';
import Link from './Link';
import TextInput from './TextInput';
import Header from './Heading';
import ClickCopyLabel from './ClickCopyLabel';
import StringUtils from '../Utils/StringUtils';
import FaqsSnippet from '../Pages/Snippets/FaqsSnippet';
import MyRecentSnippets from '../Pages/MyRecentSnippets';
import Authors from '../Pages/Authors';
import HowTo from '../Pages/HowTo';
import ShowNotes from './ShowNotes';
import GSCKwsReport from './GSCKwsReport';

export default function ArticleSideBar({ type, domain, slug, articleId, isPage = false }) {
	const [amazonKey, setAmazonKey] = useState(null);
	const [relatedArticlesList, setRelatedArticlesList] = useState(null);
	return (
		<Fragment>

			<ul className="mb-2">
			{/* {type == 'UPDATE' && !isPage && <GSCKwsReport domain={domain} page={articleId} />} */}

				{type == 'UPDATE' && !isPage && (
					<li>
						<Link
							target="_blank"
							rel="noreferrer"
							href={`https://www.${domain}/article/${slug}-${articleId}`}
							text="Live Article"
						/>
					</li>
				)}
				{type == 'UPDATE' && isPage && (
					<li>
						<Link
							target="_blank"
							rel="noreferrer"
							href={`https://${domain}${slug}`}
							text="Live Page"
						/>
					</li>
				)}

				{type == 'UPDATE' && !isPage && (
					<Item text="Notes & History" element={<ShowNotes identifier={`ARTICLE-${articleId}`} />} />
				)}

				<Item text="My Recent Snippets" element={<MyRecentSnippets />} />
				<Item text="How Tos" element={<HowTo />} />
				<Item text="Authors" element={<Authors />} />
				<Item text="Create Image Snippet" element={<ImageSnippet type="create" />} />
				<Item text="Create Faqs Snippet" element={<FaqsSnippet type="create" />} />
				<Item text="Create Youtube Snippet" element={<YoutubeSnippet type="create" />} />
				<Item text="Create Product Snippet" element={<CreateProduct />} />
			</ul>
			<Header text="Quick Snippets" type="h3" />
			<ul>
				<li className="mt-2">
					<QuickSnippet
						setter={setAmazonKey}
						value={amazonKey}
						copy={StringUtils.wrapSnippetId(`AffiliateProductSnippet#${amazonKey}`)}
						placeholder="Affiliate Product Snippet"
					/>
				</li>
				<li className="mt-2">
					<QuickSnippet
						setter={setRelatedArticlesList}
						value={relatedArticlesList}
						copy={StringUtils.wrapSnippetId(`RelatedArticlesListSnippet#${relatedArticlesList}`)}
						placeholder="Related Articles List Snippet"
					/>
				</li>
				<li className="mt-2">
					<ClickCopyLabel
						text={'___SNIPPET___SharingBarSnippet#1649855804354___END___'}
						label="Sharing Buttons"
					/>
				</li>
				<li className="mt-2">
					<ClickCopyLabel text={'___SNIPPET___TocSnippet#1649855804354___END___'} label="Table Of Content" />
				</li>
			</ul>
		</Fragment>
	);
}

const Item = ({ text, element }) => {
	return (
		<Fragment>
			<CustomModal
				trigger={<li className="no-underline hover:underline text-blue-500 cursor-pointer w-fulll">{text}</li>}
			>
				{element}
			</CustomModal>
		</Fragment>
	);
};

const QuickSnippet = ({ setter, value, copy, placeholder }) => {
	return (
		<div className="flex">
			<span className="w-4/6 mr-1">
				<TextInput
					placeholder={placeholder}
					value={value}
					onChange={(e) => {
						setter(e.target.value);
					}}
				/>
			</span>
			<span className="w-2/6">
				<ClickCopyLabel text={copy} label="Copy" />
			</span>
		</div>
	);
};
